import { Keyboard, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { Button, FormScrollView } from '@/components/base'
import { OtpInput } from '@/components/form-control'
import { useLoadingIndicator } from '@/components/LoadingIndicator'

export function OtpForm({
  control,
  onSubmit,
  requestOTP,
  verifyCode,
  automaticallyStartTimer = false
}: {
  control: any
  onSubmit: () => void
  requestOTP: () => Promise<unknown> | void
  verifyCode: string
  automaticallyStartTimer?: boolean
}) {
  const loading = useLoadingIndicator()
  const { t } = useTranslation()
  const submit = () => {
    Keyboard.dismiss()
    onSubmit()
  }

  return (
    <FormScrollView className={'flex-1'} contentContainerStyle={{ flexGrow: 1 }}>
      <View className={'grow gap-y-4 bg-background-secondary px-4 pt-4'}>
        <View className={'gap-y-4 rounded-lg border border-border-10 bg-background-primary p-4'}>
          <OtpInput
            control={control}
            onSubmit={submit}
            requestOTP={requestOTP}
            automaticallyStartTimer={automaticallyStartTimer}
            isButtonHidden={true}
          />
          <Text className={'h-[44px] text-sm text-text-secondary'}>{t('auth:otpDeliveryNotice')}</Text>
          <Button size={'md'} onPress={submit} disabled={verifyCode === '' || loading.isLoading}>
            {t('auth:confirm')}
          </Button>
        </View>
        <View className={'mt-[-16px] h-4'} />
      </View>
    </FormScrollView>
  )
}
